export default __webpack_public_path__ + "static/media/bookCoding.cf31592f.svg";